/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Tracking_Datapoints_Updatesuccess3Inputs */

const en_coinvestments_tracking_datapoints_updatesuccess3 = /** @type {(inputs: Coinvestments_Tracking_Datapoints_Updatesuccess3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salesforce data updated successfully`)
};

/**
* | output |
* | --- |
* | "Salesforce data updated successfully" |
*
* @param {Coinvestments_Tracking_Datapoints_Updatesuccess3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_tracking_datapoints_updatesuccess3 = /** @type {((inputs?: Coinvestments_Tracking_Datapoints_Updatesuccess3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Tracking_Datapoints_Updatesuccess3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_tracking_datapoints_updatesuccess3(inputs)
});
export { coinvestments_tracking_datapoints_updatesuccess3 as "coInvestments_tracking_dataPoints_updateSuccess" }